import MediaContent from "./product-media-content.jsx";
import { h, render } from "preact";

class ProductMedia extends HTMLElement {
  constructor() {
    super();
    this.mainMedia = this.querySelector("[data-product-media]");
    this.data = scrapeSectionData(this);

    const MainMedia = () => {
      return <MediaContent data={this.data} />;
    };

    render(<MainMedia />, this.mainMedia);
  }
}

if (!customElements.get("product-media")) {
  customElements.define("product-media", ProductMedia);
}
